<template>
  <div>
    <div class="page-header page-header-small clear-filter">
      <parallax
        class="page-header-image"
        style="background-image:url('img/bg3.jpg')"
      >
      </parallax>
        <div class="content-center brand">
          <h1 class="h1-seo">About us</h1>
        </div>
    </div>

    <section id="company" class="section text-center">
      <div class="container">
        <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
            <h5 class="text-primary">
Alpha Based Capital Fund Management B.V. is a privately-owned investment management firm based in the Netherlands, founded in 2004. We develop innovative solutions, leveraging the strengths of our high-conviction asset management and our recognized skills in tactical and strategic asset allocation. We adapt to our clients' needs and financial constraints, striking the right balance between quest for performance and rigorous risk management.
            </h5>
          </div>
        </div>
        </div>
      </section>
      <!-- <section id="team" class="section section-team text-center">
      <div class="container">
                <div class="row justify-content-md-center">
          <div class="col-md-12 col-lg-8">
        <div class="team">
          <div class="row justify-content-md-center">
            <div class="col-sm-6 col-md-4" v-for="person in team" :key="person.name">
              <div class="team-player">
                <img
                  :src="'img/' + person.img"
                  alt="Thumbnail Image"
                  height="250px"
                  class="img-raised"
                />
                <h5 class="title">{{person.name}}</h5>
                <p class="category pt-3 pb-0 mb-0">{{person.title}}</p>
                <p class="category">{{person.desc}}</p>
              </div>
            </div>
          </div>
          </div></div>
        </div>
      </div>
    </section> -->
    </div>
</template>
<script>
import { Parallax } from '@/components';

export default {
  name: 'index',
  bodyClass: 'index-page',
  data() {
    return {
      // team: [
      //   {
      //     img: 'joost-bouman.jpg',
      //     name: 'Joost Bouman',
      //     title: 'Managing Director',
      //     desc: 'General Manager'
      //   },
      //   {
      //     img: 'henry-van-ginkel.jpg',
      //     name: 'Henry van Ginkel',
      //     title: 'Managing Director',
      //     desc: 'Portfolio Manager'
      //   },
      //   {
      //     img: 'philip-van-wijngaarden.png',
      //     name: 'Philip van Wijngaarden',
      //     title: 'Managing Director',
      //     desc: 'Risk Manager'
      //   },
      //   {
      //     img: 'adri-verboven.png',
      //     name: 'Adri Verboven',
      //     title: 'Risk Advisor'
      //   },
      //   {
      //     img: 'patrick-lageweg.png',
      //     name: 'Patrick Lageweg',
      //     title: 'Compliance Officer'
      //   },
      // ],
    }
  },
  components: {
    Parallax
  }
};
</script>
<style></style>
